import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

function Sidebar({ collapsed, mobileOpen, setMobileOpen }) {
  return (
    <>
      {/* ===== MOBILE OVERLAY ===== */}
      {mobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* ===== SIDEBAR ===== */}
      <div
        className={`sidebar d-flex flex-column ${
          mobileOpen ? "sidebar-open" : ""
        }`}
        style={{
          width: collapsed ? "80px" : "250px",
        }}
      >
        {/* LOGO */}
        <div className="text-center mb-5">
          <img
            src={logo}
            alt="Logo"
            style={{
              width: collapsed ? "50px" : "180px",
              transition: "0.3s",
            }}
          />
        </div>

        {/* MENU */}
        <ul className="nav flex-column gap-2">
          <SidebarItem to="/" label="Dashboard" collapsed={collapsed} />
          <SidebarItem to="/order" label="Orders" collapsed={collapsed} />
          <SidebarItem to="/purchase" label="Purchases" collapsed={collapsed} />
          <SidebarItem to="/inventory" label="Inventory" collapsed={collapsed} />
          <SidebarItem to="/billing" label="Billing" collapsed={collapsed} />
        </ul>

        {/* FOOTER */}
        <div className="mt-auto text-center small pt-4">
          {!collapsed && "© 2026 Star Laser India"}
        </div>
      </div>
    </>
  );
}

function SidebarItem({ to, label, collapsed }) {
  return (
    <li className="nav-item">
      <NavLink
        to={to}
        end={to === "/"}
        className={({ isActive }) =>
          `sidebar-link ${isActive ? "active-sidebar" : ""}`
        }
      >
        {collapsed ? label.charAt(0) : label}
      </NavLink>
    </li>
  );
}

export default Sidebar;